import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Input,
  FormLabel,
  Divider,
} from "@mui/joy";
import { useTranslation, Trans } from "react-i18next";
import SeoHelmet from "../components/SeoHelmet";
import i18n from "../i18n";
const CreateEvent = () => {
  const { t } = useTranslation();
  const [date, setDate] = useState('');
  const [gender, setGender] = useState(null);
  const [babyName, setBabyName] = useState('');
  const [created, setCreated] = useState(false);
  const [eventId] = useState(() => Math.random().toString(36).substring(2, 8));

  const toggleGender = (value) => {
    setGender((prev) => (prev === value ? null : value));
  };

  const handleCreate = async () => {
    if (!date) {
      alert(t('create.alertMissingDate'));
      return;
    }

    try {
      const response = await fetch('https://revealoo.com/api/create_event.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          eventId,
          date,
          name: babyName,
          gender
        })
      });

      const data = await response.json();

      if (data.success) {
        setCreated(true);
      } else {
        alert(t('create.errorGeneric') + ': ' + (data.error || t('create.errorUnknown')));
      }
    } catch (error) {
      alert(t('create.errorConnection'));
      console.error(error);
    }
  };

  const lang = i18n.language; 
const eventUrl = `${window.location.origin}/${lang}/c/${eventId}`;
const genderUrl = `${window.location.origin}/${lang}/set/${eventId}`;

  const copy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      alert(t('create.copied'));
    } catch {
      alert(t('create.copyFailed'));
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 500,
        mx: 'auto',
        mt: 6,
        px: 3,
        py: 4,
        background: '#fff',
        borderRadius: '16px',
        boxShadow: 'lg',
        textAlign: 'center',
        position: 'relative',
      }}
    >
            <SeoHelmet
        title={t("meta.createTitle")}
        description={t("meta.createDesc")}
      />
      {!created ? (
        <>
          <Typography level="h2" sx={{ mb: 4 }}>
            {t('create.title')}
          </Typography>

          <FormLabel sx={{ display: 'block', mb: 1, textAlign: 'left' }}>
            {t('create.dateLabel')}
          </FormLabel>
          <Input
            type="datetime-local"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            sx={{ mb: 3 }}
          />

          <FormLabel sx={{ display: 'block', mb: 1, textAlign: 'left' }}>
            {t('create.nameLabel')}
          </FormLabel>
          <Input
            placeholder={t('create.namePlaceholder')}
            value={babyName}
            onChange={(e) => setBabyName(e.target.value)}
            sx={{ mb: 3 }}
          />

          <FormLabel sx={{ display: 'block', mb: 1, textAlign: 'left' }}>
            {t('create.genderLabel')}
          </FormLabel>

          <Typography level="body-sm" sx={{ mb: 1, fontStyle: 'italic', color: '#555' }}>
            {t('create.genderHint')}
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, mb: 4, justifyContent: 'center' }}>
            <Button
              variant={gender === 'boy' ? 'solid' : 'soft'}
              color="primary"
              onClick={() => toggleGender('boy')}
            >
              {t('gender.boy')}
            </Button>
            <Button
              variant={gender === 'girl' ? 'solid' : 'soft'}
              color="danger"
              onClick={() => toggleGender('girl')}
            >
              {t('gender.girl')}
            </Button>
          </Box>

          <Button
            size="lg"
            color="primary"
            sx={{ borderRadius: '12px', fontWeight: 600 }}
            onClick={handleCreate}
          >
            {t('create.submit')}
          </Button>
        </>
      ) : (
        <>
          <Typography level="h2" sx={{ mb: 2 }}>
            {t('create.done')}
          </Typography>

          {babyName && (
            <Typography level="body-md" sx={{ mt: 1, mb: 3 }}>
              <Trans i18nKey="create.babyNameMessage" components={{ b: <b /> }} values={{ name: babyName }} />
            </Typography>
          )}

          <Typography level="body-lg" sx={{ mb: 2 }}>
            {t('create.shareEventLink')}
          </Typography>

          <Box
            sx={{
              p: 2,
              border: '1px solid #ccc',
              borderRadius: '12px',
              wordBreak: 'break-all',
              background: '#f9f9f9',
              mb: 2,
            }}
          >
            {eventUrl}
            <Button size="sm" onClick={() => copy(eventUrl)} sx={{ ml: 2 }}>
              {t('create.copy')}
            </Button>
          </Box>

          {!gender && (
            <>
              <Typography level="body-lg" sx={{ mt: 2, mb: 1 }}>
                {t('create.shareGenderLink')}
              </Typography>

              <Box
                sx={{
                  p: 2,
                  border: '1px solid #ccc',
                  borderRadius: '12px',
                  wordBreak: 'break-all',
                  background: '#f9f9f9',
                }}
              >
                {genderUrl}
                <Button size="sm" onClick={() => copy(genderUrl)} sx={{ ml: 2 }}>
                  {t('create.copy')}
                </Button>
              </Box>
            </>
          )}

          <Divider sx={{ my: 4 }} />

          <Button
  onClick={() => window.location.href = `/${i18n.language}/c/${eventId}`}
  variant="soft"
>
  {t('create.viewEvent')}
</Button>
        </>
      )}
    </Box>
  );
};

export default CreateEvent;
